import React from 'react';

const Repeat = (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.00006H8C5.79086 8.00006 4 9.79092 4 12.0001V13.0001C4 14.6569 5.34315 16.0001 7 16.0001V18.0001C4.23858 18.0001 2 15.7615 2 13.0001V12.0001C2 8.68635 4.68629 6.00006 8 6.00006H12V4.72806C12 4.62021 12.0349 4.51525 12.0994 4.42885C12.2647 4.20761 12.578 4.16222 12.7992 4.32747L15.6562 6.46143C15.6951 6.49048 15.7296 6.52504 15.7585 6.56402C15.9231 6.78576 15.8768 7.09893 15.655 7.26351L12.798 9.3841C12.7118 9.44807 12.6073 9.48261 12.5 9.48261C12.2239 9.48261 12 9.25875 12 8.98261V8.00006Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0582 16H15.9999C18.2091 16 19.9999 14.2091 19.9999 12V11C19.9999 9.34315 18.6568 8 16.9999 8V6C19.7613 6 21.9999 8.23858 21.9999 11V12C21.9999 15.3137 19.3136 18 15.9999 18H12.0582V18.9825C12.0582 19.2587 11.8344 19.4825 11.5582 19.4825C11.4509 19.4825 11.3464 19.448 11.2602 19.384L8.4032 17.2635C8.18146 17.0989 8.13513 16.7857 8.29971 16.564C8.32864 16.525 8.3631 16.4904 8.402 16.4614L11.259 14.3274C11.4803 14.1622 11.7936 14.2075 11.9588 14.4288C12.0234 14.5152 12.0582 14.6202 12.0582 14.728V16Z"
      fill="black"
    />
  </svg>
);

export default Repeat;
